// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { savedOrderListTableStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListTable";
import dataTableStyles from "@tps/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { css } from "styled-components";

savedOrderListTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

savedOrderListTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

savedOrderListTableStyles.subtotalCell = {
    alignX: "left",
};

savedOrderListTableStyles.subtotalHeader = {
    sortClickableProps: {
        css: css`
            justify-content: flex-start;
            width: 100%;
        `,
    },
};

savedOrderListTableStyles.container = {};
